
<h6>User Settings</h6>
  <div>
    <ejs-tab id="element" width="'100%'">
      <e-tabitems>
        <e-tabitem *ngIf="loginService.user.enableFracX" [header]='{ text: "FracX" }'>
          <ng-template #content>
            <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
              <div style="margin-top: 10px; margin-left: 5px">
                <mat-dialog-content>
                  <div class="form-group">
                    <div>
                      <label for="enableFracXNotifications">
                        Enable Notifications
                        <input formControlName="enableFracXNotifications"
                               type="checkbox"
                               class="form-control"
                               id="enableFracXNotifications"
                               name="enableFracXNotifications" />
                      </label>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="editForm?.value && editForm.value.enableFracXNotifications">
                    <div>
                      <label for="allRegions">
                        Notify for All Regions
                        <input formControlName="allRegions"
                               type="checkbox"
                               class="form-control"
                               id="allRegions"
                               name="allRegions" />
                      </label>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="editForm?.value && editForm.value.enableFracXNotifications && !editForm.value.allRegions">
                    <div>
                      <label for="followedRegions">
                        Notify for Selected Regions
                        <ejs-multiselect formControlName="followedRegions" id="followedRegions"
                                         [dataSource]="filters.regions"
                                         [fields]="{ text: 'caption', value: 'value' }"
                                         [placeholder]="'Select Regions'"
                                         [width]="'400px'"
                                         [allowFiltering]="true" />
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div>
                      <label for="enableDaysFilter">
                        Notify for specific days
                        <input formControlName="enableDaysFilter"
                               type="checkbox"
                               class="form-control"
                               id="enableDaysFilter"
                               name="enableDaysFilter" />
                      </label>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="editForm?.value && editForm.value.enableFracXNotifications && editForm.value.enableDaysFilter">
                    <div>
                      <label for="fracXDaysOut" style="display:grid">
                        Only Notify for Schedules Within {{editForm.value.fracXDaysOut}} Days
                        <mat-slider [max]="100" style="margin-top: 20px" [min]="1" [step]="1" [discrete]="false" [showTickMarks]="true">
                          <input formControlName="fracXDaysOut" matSliderThumb #slider>
                        </mat-slider>
                      </label>
                    </div>
                  </div>
                </mat-dialog-content>
              </div>
              <button [disabled]="!editForm.valid" class="save-btn" type="submit"><span>Save Changes</span></button>
            </form>
          </ng-template>
        </e-tabitem>
        <e-tabitem [header]='{ text: "WDX" }'>
          <ng-template #content>
            <div class="wdxDiv">
              <label *ngIf="loginService.user.wdxUserName">Current User: {{loginService.user.wdxUserName}}</label>

              <label class="wdxlbl" for="txtWdxUser">WDX User Name</label>
              <input id="txtWdxUser" name="txtWdxUser" class="wdxuser" type="text" [(ngModel)]="wdxUser" />
              <label class="wdxlbl" for="txtWdxPass">WDX Password</label>
              <input id="txtWdxPass" name="txtWdxPass" class="wdxpass" type="password" [(ngModel)]="wdxPassword" />

              <button class="wdx-btn" (click)="loginWdx()"><span>Login to WDX</span></button>
              <button *ngIf="loginService.user.wdxUserName" class="wdx-btn" (click)="logoutWdx()"><span>Logout of WDX</span></button>
            </div>
          </ng-template>
        </e-tabitem>
<!--<e-tabitem [header]='{ text: "WDX" }'>
  <ng-template #content>
    <div>WDX</div>
  </ng-template>
</e-tabitem>-->
      </e-tabitems>
    </ejs-tab>

  </div>

